import styled from '@emotion/styled';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings, Fonts, mediaQuery } from '@styles/index';
import Image from '@base/Image';
import H3 from '@base/H3/H3';
import H5 from '@base/H5/H5';
import P1 from '@base/P1/P1';
import useDarkModeStatus from '@stores/useDarkModeStatus';
import { getIsDarkModeOn } from '@stores/selectors/darkModeStatusSelectors';

const Wrapper = styled.div`
  grid-column: span 16;
  margin-top: ${Spacings.SPACING_20B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_14B};
  }
`;

const Title = styled(H3)`
  font-weight: ${Fonts.HEAVY};
`;

const ListContainer = styled.div`
  margin-top: ${Spacings.SPACING_6B};
  display: grid;
  grid-template-columns: repeat(2, 2fr);
  grid-column-gap: ${Spacings.SPACING_4B};
  grid-row-gap: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    display: flex;
    flex-direction: column;
    grid-column-gap: ${Spacings.SPACING_0B};
    grid-row-gap: ${Spacings.SPACING_0B};
    box-shadow: ${boxShadowGenerator()};
    padding: ${Spacings.SPACING_4B};
    border-radius: ${Spacings.SPACING_2B};
    background: var(--color-base-1);
    > div:not(:last-child) {
      ${mediaQuery.uptoMobile} {
        margin-bottom: ${Spacings.SPACING_4B};
      }
    }
  }
`;

const CardContainer = styled.div`
  min-height: 172px;
  background: var(--color-base-1);
  box-shadow: ${boxShadowGenerator()};
  padding: ${Spacings.SPACING_6B};
  border-radius: ${Spacings.SPACING_2B};
  display: flex;
  flex-direction: column;
  ${mediaQuery.uptoMobile} {
    box-shadow: none;
    border-radius: ${Spacings.SPACING_0B};
    padding: ${Spacings.SPACING_0B};
    flex-direction: row;
    min-height: unset;
    width: unset;
  }
`;

const ImageWrapper = styled.div``;

const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${mediaQuery.uptoMobile} {
    margin-left: ${Spacings.SPACING_3B};
  }
`;

const CardTitle = styled(H5)`
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_0B};
  }
`;

const CardDescription = styled(P1)`
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_2B};
`;

const WhatWillYouLearn = ({ courseInfo }) => {
  const isDarkModeOn = useDarkModeStatus(getIsDarkModeOn);
  if (!courseInfo) return null;
  return (
    <Wrapper>
      {courseInfo?.header && <Title>{courseInfo.header}</Title>}
      <ListContainer>
        {courseInfo?.data?.map((learning) => {
          return (
            <LearningCard
              isDarkModeOn={isDarkModeOn}
              key={learning?.text}
              item={learning}
            />
          );
        })}
      </ListContainer>
    </Wrapper>
  );
};

const LearningCard = ({ item, isDarkModeOn }) => {
  const icon = isDarkModeOn ? item?.darkmode_icon : item?.icon;

  return (
    <CardContainer>
      <ImageWrapper>
        {icon && <Image src={icon} width={40} height={40} alt="icon" />}
      </ImageWrapper>
      <CardInfo>
        {item?.text && <CardTitle>{item.text}</CardTitle>}
        {item?.description && (
          <CardDescription>{item.description}</CardDescription>
        )}
      </CardInfo>
    </CardContainer>
  );
};
export default WhatWillYouLearn;
